/**
 * @author Yaochao
 * @date 2021/7/9 18:02
 * @description search中select组件封装
 */
import React, {useEffect, useState} from "react";
import {DownOutlined} from '@ant-design/icons';
import {Select} from "antd";

/**
 *
 * @param title 字段描述
 * @param valueKey value的key
 * @param defaultValue 默认值，会随着父组件值变化
 * @param setSearchParams 父组件传递，无需设置
 * @param resetFlag 父组件传递，无需设置
 * @returns {*}
 * @constructor
 */
export const ZkSelect = (props) => {
    const {
        title: title,
        valueKey: valueKey,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        setSearchParams: setSearchParams,
        setDefaultSearchParams: setDefaultSearchParams,
        defaultValue: defaultValue,
        value: pValue,
        resetKeys: resetKeys,
        placeholder: placeholder,
        afterChange: afterChange, //onChange时的回调，参数是当前选中的 value
    } = props;
    const [value, setValue] = useState(defaultValue);

    /**
     * value值变化处理，并把值通过setSearchParams传递给父组件
     * @param val
     */
    function onChange(val) {
        if (valueKey) {
            setSearchParams({[valueKey]: val});
            setValue(val);
        }
        /**
         * value变化，执行回调,供父组件操作value
         */
        if (afterChange) {
            afterChange(val);
        }
    }


    /**
     * 向group传递默认值
     */
    useEffect(() => {
        if (valueKey) {
            setDefaultSearchParams({[valueKey]: defaultValue});
        }
    }, []);

    /**
     * 向group传递默认值
     */
    useEffect(() => {
        if (valueKey) {
            if (pValue != undefined && pValue != value) {
                setValue(pValue);
                setSearchParams({[valueKey]: pValue})
            }
        }
    }, [pValue]);

    useEffect(() => {
        if (resetKeys.indexOf(valueKey) != -1) {
            setValue(defaultValue)
        }
    }, [resetKeys]);

    return (
        <li className='sg-item'>
            <label className='sg-item-title'>{title}</label>
            <div className='sg-item-wraper'>
                <Select
                    value={value}
                    {...props}
                    getPopupContainer={triggerNode => triggerNode.parentNode.parentNode}
                    dropdownMatchSelectWidth={dropdownMatchSelectWidth} onChange={onChange}
                    showSearch
                    optionFilterProp="children"
                    placeholder={placeholder}
                    filterOption={(input, option) => {
                        let optionVal = option.props.children + '';
                        return (
                            optionVal.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        )
                    }}
                >
                    {
                        props.children
                    }
                </Select>
            </div>
        </li>
    );
};

export default ZkSelect